export function getTranslation(
    translate_key: string,
    translations: Record<string, string>,
    content_values?: Record<string, string | number | Date>
): string {
    let text = translations[translate_key]

    if (text == undefined) {
        text = translate_key
    }

    if (content_values && Object.keys(content_values).length > 0) {
        Object.keys(content_values).forEach((key: string) => {
            if (content_values && content_values[key] != undefined) {
                const val = content_values[key] as string
                text = text.split(`{${key}}`).join(val)
            }
        })
    }

    return text
}
